const master = 'master';
const wordings = [
    '%sclub',
    'superior %',
    'legend %',
    'ultimate %',
    '%punkte',
    '%points',
    '%rang',
    '%rängen',
];

export default (value) => {
    let newText = value;

    wordings.forEach((word) => {
        let regex = new RegExp();
        const prependMaster = (word[0] === '%');
        const appendMaster = (word[word.length - 1] === '%');

        if (prependMaster) {
            regex = new RegExp(`${master}${word.substring(1)}`, 'gi');
            newText = newText.replace(regex, `<span class="text-no-wrap text-uppercase font-weight-bold">${master}</span><span class="text-uppercase font-weight-regular">${word.substring(1)}</span>`);
        }

        if (appendMaster) {
            regex = new RegExp(`${word.slice(0, -1)}${master}`, 'gi');
            newText = newText.replace(regex, `<span class="text-no-wrap text-uppercase font-weight-regular">${word.slice(0, -1)}</span><span class="text-uppercase font-weight-bold">${master}</span>`);
        }
    });

    return newText;
};
